import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './TaxAndDutiesIncluded.module.scss'

export interface TaxAndDutiesIncludedProps {
  className?: string
}

export const TaxAndDutiesIncluded: FC<TaxAndDutiesIncludedProps> = ({ className }) => {
  const { t } = useTranslation()
  const enableTaxAndDuties = useSplitTest('duties_and_taxes_inc_v1', 'b')
  const { store } = useContext(MetadataContext)
  const show = ['19', '20', '3', '8', '28', '33', '34', '21', '32', '29', '27', '36'].includes(store.id)
  if (!show || !enableTaxAndDuties) {
    return null
  }
  return (
    <p className={clsx(styles.taxAndDutiesIncluded, className)}>
      {t('header:ALL_DUTIES_AND_TAXES_INCLUDED', '[All duties and taxes included]')}
    </p>
  )
}

export const TaxAndDutiesIncludedV2: FC<TaxAndDutiesIncludedProps> = ({ className }) => {
  const { t } = useTranslation()
  const { store } = useContext(MetadataContext)
  const show = ['19', '20', '3', '8', '28', '33', '34', '21', '32', '29'].includes(store.id)
  const showUS = ['27', '36'].includes(store.id)
  if (!show) {
    return null
  }
  return (
    <p className={clsx(styles.taxAndDutiesIncluded, className)}>
      {show && t('header:ALL_DUTIES_AND_TAXES_INCLUDED', '[All duties and taxes included]')}
      {showUS && t('header:TAX_ADDED_AT_CHECKOUT', '[Tax added at checkout]')}
    </p>
  )
}

